import type { CmsContentDictionary } from '$cms/index';
import { CLOUDINARY_URL } from '$constants/cloudinary';
import { getShortTextByKey, getImageByKey } from '$cms/getDataByKey';

export const getCmsData = (cmsData: CmsContentDictionary) => {
  const getShortText = getShortTextByKey.bind(cmsData);
  const getImage = getImageByKey.bind(cmsData);
  return {
    textPostcode: getShortText('vrmLookup.text.postcode', 'Your postcode'),
    textPostcodeRequired: getShortText('vrmLookup.text.postcode.required', 'Enter a correct postcode'),
    textPostcodeInvalid: getShortText('vrmLookup.text.postcode.invalid', 'Invalid postcode'),
    textRegistrationNumber: getShortText('vrmLookup.text.registrationNumber', 'Your registration number'),
    textRegistrationNumberRequired: getShortText(
      'vrmLookup.text.registrationNumber.required',
      'Enter a correct VRM'
    ),
    textRegistrationNumberInvalid: getShortText('vrmLookup.text.registrationNumber.invalid', 'Invalid VRM'),
    textCtaGetInstantQuote: getShortText('vrmLookup.cta.getInstantQuote', 'Get an instant quote'),
    textCtaIsReferral: getShortText('vrmLookup.cta.isReferral', 'Redeem now'),
    textCtaIsFree: getShortText('vrmLookup.cta.isFree', 'Book a Free Check'),
    textCtaIsFromErrorPage: getShortText('vrmLookup.cta.isFromErrorPage', 'Try again'),
    imagePostcode: getImage('vrmLookup.image.postcode', {
      img: { original_secure_url: `${CLOUDINARY_URL}/icons/icon_postcode_vhjmk6.svg`, width: 19, height: 21 },
      alt: 'Postcode',
      title: '',
    }).img.original_secure_url,
    imagePostcodeBlue: getImage('vrmLookup.image.postcodeBlue', {
      img: {
        original_secure_url: `${CLOUDINARY_URL}/icons/icon_postcode_blue_xrhv7b.svg`,
        width: 19,
        height: 21,
      },
      alt: 'Postcode',
      title: '',
    }).img.original_secure_url,
    imageRegistrationNumber: getImage('vrmLookup.image.registrationNumber', {
      img: {
        original_secure_url: `${CLOUDINARY_URL}/icons/icon_vrm_epcna1.svg`,
        width: 26,
        height: 20,
      },
      alt: 'VRM',
      title: '',
    }).img.original_secure_url,
    imageRegistrationNumberBlue: getImage('vrmLookup.image.registrationNumberBlue', {
      img: {
        original_secure_url: `${CLOUDINARY_URL}/icons/icon_vrm_blue_ogdzpf.svg`,
        width: 26,
        height: 20,
      },
      alt: 'VRM',
      title: '',
    }).img.original_secure_url,
  };
};
